import { render } from "./ExpenseBillData.vue?vue&type=template&id=1b661e48&scoped=true"
import script from "./ExpenseBillData.vue?vue&type=script&lang=js"
export * from "./ExpenseBillData.vue?vue&type=script&lang=js"

import "./ExpenseBillData.vue?vue&type=style&index=0&id=1b661e48&scoped=true&lang=css"
import "./ExpenseBillData.vue?vue&type=style&index=1&id=1b661e48&lang=less&scoped=true"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b661e48"]])

export default __exports__